import React, { useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { useBookingData } from "../../hooks/useBookingData";

const PDFViewer = ({ bookingId, versionKey = "", height = "600px", className = "" }) => {
  const { fetchContractsBlob } = useBookingData();
  const { data: pdfBlob, error, isLoading } = useQuery(
    ["contract-pdf", bookingId, versionKey],
    () => fetchContractsBlob(bookingId),
    {
      enabled: !!bookingId,
      staleTime: 1000 * 60 * 10,
    }
  );

  const pdfUrl = useMemo(() => (pdfBlob ? URL.createObjectURL(pdfBlob) : ""), [pdfBlob]);

  useEffect(() => {
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [pdfUrl]);

  if (isLoading) return <p>Loading PDF...</p>;
  if (error) return <p>Error loading PDF: {error.message}</p>;
  if (!pdfUrl) return null;

  return (
    <div className={`pdf-viewer ${className}`.trim()}>
      <iframe
        src={pdfUrl}
        title="Contract PDF"
        width="100%"
        height={height}
        style={{ border: "none" }}
      />
      <a className="btn btn-sm btn-outline-primary mt-3" href={pdfUrl} target="_blank" rel="noopener noreferrer">
        Open in New Tab
      </a>
    </div>
  );
};

export default PDFViewer;
